import { ReactComponent as CloseIcon } from 'assets/icons/closeIcon.svg';
import { CloseIconWrapper, SubmitButtonsWrapper, Wrapper } from '../SaveModal/SaveModal.style';
import { ModalType } from 'components/Dialogs/types';
import { closeWizard } from '../../../api/api';
import { Button } from '@mui/material';

const CloseAppModal = ({ toggleModalOpen }: { toggleModalOpen: (type: ModalType, file?: string | number) => void }) => {
    return (
        <Wrapper>
            <h1>Czy na pewno chcesz opuścić tę stronę?</h1>
            <p>
                Jeżeli opuścisz tę stronę, wprowadzone zmiany zostaną <br />
                utracone.
            </p>
            <CloseIconWrapper>
                <CloseIcon onClick={() => toggleModalOpen(null)} />
            </CloseIconWrapper>
            <SubmitButtonsWrapper style={{ marginTop: '10px' }}>
                <Button variant='text' onClick={closeWizard}>
                    Opuść
                </Button>
                <Button variant='contained' onClick={() => toggleModalOpen(null)}>
                    Pozostań
                </Button>
            </SubmitButtonsWrapper>
        </Wrapper>
    );
};

export default CloseAppModal;
